// Build-time flags for features that aren't released to production yet. Gatsby inlines GATSBY_*
// env vars at build time, so a flag is only on when its var is set to "true" for that build -
// leaving it unset (as the production workflow does) keeps the feature off.
const isEnabled = (value?: string) => value === 'true'

export const featureFlags = {
  // Perses-based device charts (chart tabs, editor, org default graphs). When off, devices show
  // the legacy ECharts view driven by the flat IoTChartConfig[] chart_configs.
  persesCharts: isEnabled(process.env.GATSBY_FEATURE_PERSES_CHARTS),
  // Models (krane-infer pipelines) page and nav item.
  models: isEnabled(process.env.GATSBY_FEATURE_MODELS),
}
